import React from "react";
import { titles } from "constants/titles";
import { BillingIcon } from "assets/SVGs/SVGs";
import CustomButton from "components/widgets/custom-button/CustomButton";
import { ROUTES_CONSTANTS } from "routes/route-constants";
import { useHistory } from "react-router-dom";

const BillingDetailsCard = ({
  medicalUserDetail,
  bankDetails,
  cardDetails,
  cardList,
  accountTypes,
  allRegionList
}) => {
  const history = useHistory();

  const getCardDetail = () => {
    if (!cardDetails?.expiration_year) return;
    return `XXXX-XXXX-XXXX-${cardDetails?.last_4_digits}\nExp: ${cardDetails?.expiration_month
      }/${cardDetails?.expiration_year?.toString()?.slice(-2)}`;
  };

  const getButtonText = () => {
    if (medicalUserDetail?.payment_method_type === "bank") {
      return bankDetails ? titles?.edit_bank : titles?.add_bank;
    } else {
      return cardDetails ? titles?.edit_card : titles?.add_card;
    }
  };

  const renderBillingInfo = () => {
    if (medicalUserDetail?.payment_method_type === "bank" && bankDetails) {
      return (
        <div className="sp_billing_info">
          <div className="sp_billing_row">
            <span className="sp_billing_label">{titles?.account_type}:</span>
            <span className="sp_billing_value">
              {bankDetails?.display_value}
            </span>
          </div>
          <div className="sp_billing_row">
            <span className="sp_billing_label">{titles?.routing_number}:</span>
            <span className="sp_billing_value">
              {bankDetails?.routing_number}
            </span>
          </div>
          <div className="sp_billing_row">
            <span className="sp_billing_label">{titles?.account_number}:</span>
            <span className="sp_billing_value">****************</span>
          </div>
        </div>
      );
    } else if (cardDetails) {
      return (
        <div className="sp_card_info">
          <img
            src={cardDetails?.image_url}
            alt="Card"
            className="sp_card_logo"
          />
          <p className="sp_card_details">{getCardDetail()}</p>
        </div>
      );
    } else {
      return (
        <p className="sp_no_payment_text">
          {titles?.no_payment_detail}
        </p>
      );
    }
  };

  return (
    <div className="sp_billing_details_card">
      <div className="sp_card_header">
        <h3 className="sp_card_title">{titles?.billing_details}</h3>
        <div className="sp_card_icon">
          <BillingIcon />
        </div>
      </div>
      <div className="sp_separator"></div>
      {renderBillingInfo()}
      <CustomButton
        text={getButtonText()}
        width="100%"
        onClick={() =>
          history.push(ROUTES_CONSTANTS?.billingDetails, {
            medicalUserDetail: medicalUserDetail,
            payments: {
              cardList,
              cardDetails,
              bankDetails,
              accountTypes,
            },
            allRegionList,
          })
        }
      />
    </div>
  );
};

export default BillingDetailsCard;
